module.exports = __webpack_public_path__ + "media/images/icon__live-37027802b6288fe35446bc379ddcff63.png";